<template>
  <div class="table">
    <el-table :data="tableData" style="width: 100%" :header-cell-style="{
      backgroundColor: '#0E59CB',
      color: '#fff',
    }" :default-sort="{ prop: 'date', order: 'descending' }" ref="singleTable" :highlight-selection-row="false"
      :row-class-name="tableRowClassName" @row-click="rowClick">
      <el-table-column prop="xxdz" show-overflow-tooltip label="详细地址" sortable>
        <template slot-scope="scope">
          {{ scope.row.houseName }}/{{ scope.row.buildingName }}/{{ scope.row.unitName }}/{{ scope.row.floorName }}/{{
      scope.row.roomName }}
        </template>
      </el-table-column>
      <el-table-column prop="content" show-overflow-tooltip label="问题描述" sortable>
      </el-table-column>

      <el-table-column show-overflow-tooltip prop="clrxm" width="180px" sortable  label="状态">
        <template slot-scope="scope">
          <!-- {{
      scope.row.state == 1 ? "待处理" :
        scope.row.state == 2 ? "已处理" :
          scope.row.state == 3 ? "已取消" :
            "--"
    }} -->

    
         <el-steps :space="80" active="1"  v-if="scope.row.state == 1" finish-status="success">
            <el-step title="待处理"></el-step>
            <el-step title="已处理"></el-step>
          </el-steps>

          <el-steps :space="80" active="2" v-if="scope.row.state == 2" finish-status="success">
            <el-step title="待处理"></el-step>
            <el-step title="已处理"></el-step>
          </el-steps>

          <el-steps :space="80" active="2" v-if="scope.row.state == 3" finish-status="success">
            <el-step title="待处理"></el-step>
            <el-step title="已取消"></el-step>
          </el-steps>



        </template>
      </el-table-column>

      <el-table-column prop="clzt" show-overflow-tooltip width="120px" sortable label="处理结果">
        <template slot-scope="scope">
          <div>
            {{ scope.row.handleContent }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="yema">
      <Pagination style="margin-top: 10px" v-show="query.total > 0" :total="query.total" :limit.sync="query.pageSize"
        :page.sync="query.pageNum" round="false" :currentPageSize="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper" @pagination="changePage" />
    </div>

    <!-- 详情-->

    <el-dialog title="报事报修详情" :visible.sync="dialogVisible" width="80%" class="tsinfoWrapper">
      <el-row>
        <el-col :span="24">
          <div class="textBar">
            <span class="label">详细地址：</span>
            <span class="value">

              {{ currentData.houseName }}/{{ currentData.buildingName }}/{{ currentData.unitName }}/{{
      currentData.floorName
    }}/{{ currentData.roomName }}

            </span>
          </div>

        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <div class="textBar">
            <span class="label">姓名：</span>
            <span class="value">{{ currentData.contactName }}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="textBar">
            <span class="label">联系电话：</span>
            <span class="value">
              {{ currentData.contactMobile }}
            </span>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <div class="textBar">
            <span class="label">标题：</span>
            <span class="value">{{ currentData.title }}</span>
          </div>
        </el-col>

        <el-col :span="12">
          <div class="textBar">
            <span class="label">问题描述：</span>
            <span class="value">
              {{ currentData.content }}
            </span>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <div class="textBar">
            <span class="label">状态：</span>
            <span class="value">
              {{
      currentData.state == 1 ? "待处理" :
        currentData.state == 2 ? "已处理" :
          currentData.state == 3 ? "已取消" :
            "--"
    }}
            </span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="textBar">
            <span class="label">处理时间：</span>
            <span class="value">
              {{ currentData.handleTime }}
            </span>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <div class="textBar">
            <span class="label">处理结果：</span>
            <span class="value">{{ currentData.handleContent }}</span>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <div class="textBar">
            <span class="label">附件：</span>
            <span class="value">
              <el-image v-for="(item, index) in appealsFile" :src="item.url"
                style="width: 100px; height: 100px;margin-right: 10px;" :preview-src-list="[item.url]">
              </el-image>
            </span>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <div class="textBar">
            <span class="label">处理附件：</span>
            <span class="value">
              <p style="cursor: pointer;" @click="showFile(item.url)" v-for="(item,index) in clFile" :key="index">{{ item.name }}</p>
            </span>
          </div>
        </el-col>
      </el-row>

     

      <!-- <div style="font-size: 16px;margin: 30px 0 20px 0;color: #fff;">办理记录列表</div> -->

   
      <div style="margin-top: 20px;"></div>

    </el-dialog>

  </div>
</template>

<script>
// import detail from "@/api/detail.js";

import api from "@/api/repair.js";

import wyqyId from "../../config";

export default {
  data() {
    return {
      dialogVisible: false,
      tableData: [],
      query: {
        total: 0,
        pageNum: 1,
        pageSize: 6,
      },
      reverse: true,
      appealsFile: [],
      clFile:[],
     
      currentData: {},
      timer: null,
    };
  },
  mounted() {
    this.initPage();
    this.timer = setInterval(() => {
      this.initPage();
    }, 5000)
  },
  methods: {
    showFile(url) {
      window.open(url)
    },
    initPage() {
      let params = {
        ...this.query,
        wyqyId: wyqyId,
      };
      api.fwtzlist(params).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.list;
          this.query.total = res.data.data.total;
        }
      });
    },

    changePage(val) {
      this.query.pageNum = val;
      this.initPage();
    },
    //奇偶行背景色不同
    tableRowClassName({ rowIndex }) {
      if ((rowIndex + 1) % 2 === 0) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
    rowClick(row) {
      this.dialogVisible = true;

      api.bxInfo({ id: row.id }).then(res => {
        if (res.data.code == 200) {
          this.currentData = res.data.data;
          this.appealsFile = res.data.data.reportFile || [];
          this.clFile = res.data.data.handleFile || [];

          
        }
      })

      // let params = {
      //   id: row.id,
      //   lx: 3,
      // };
      // detail.bsbxinfo(params).then((res) => {
      //   if (res.data.code == 200) {
      //     this.currentData = res.data.data;
      //     this.activities = res.data.data.jds || [];
      //   }
      // });

    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>

<style lang="scss" scoped>
.table {
  position: relative;
  height: 415px;
}

.yema {
  position: absolute;
  bottom: 20px;
  right: 0;
}

::v-deep.el-table .warning-row {
  background-color: #0f53a5 !important;
  color: #fff !important;
}

::v-deep.el-table .success-row {
  background-color: #193a5c !important;
  color: #fff !important;
}

::v-deep.el-table tbody tr:hover>td {
  background-color: unset !important;
}

::v-deep.el-table__body {
  border-color: #0f53a5 !important;
}

.el-table {
  border-bottom: 1px solid #1763e8;
  border-right: 1px solid #1763e8;
  margin: 0 auto;
}

::v-deep.el-table th {
  border: 1px solid #1763e8 !important;
  border-right: none !important;
  border-bottom: none !important;
}

::v-deep.el-table td {
  border: 1px solid #1763e8;
  height: 20px;
  border-right: none !important;
  border-bottom: none !important;
}

::v-deep .el-table__empty-block {
  background-color: #0e59cb;
}

::v-deep .el-table__empty-text {
  color: #fff;
}

::v-deep .el-table__empty-block {
  background-color: #0e59cb;
}

::v-deep .el-table__empty-text {
  color: #fff;
}


::v-deep .el-carousel__container {
  height: 350px;
}

::v-deep .el-dialog {
  width: 800px;
  min-height: 400px;
  background: url("../../assets/images/dialog_bg2.png") no-repeat;
  background-size: 100% 100%;
  border-radius: 24px;

  color: #fff;
  position: relative;

  overflow-y: auto !important;

  display: flex;
  flex-direction: column;

}

::v-deep .el-dialog__title {
  color: #fff !important;
  font-size: 20px;
  font-weight: 600;
}

::v-deep .el-dialog__header {
  margin: 0 20px;
  border-bottom: 1px solid #338bea;
}

::v-deep .el-form-item__label {
  color: #fff;
}

::v-deep .el-dialog__body {
  color: #fff;
  height: 700px;
}

::v-deep .el-form-item {
  margin: 0;
}

::v-deep .el-dialog__body {
  padding: 10px 20px;
  overflow-x: hidden;
  overflow-y: auto;
}

.value,
.label {
  margin-bottom: 15px;
  font-size: 16px;

  // &.label {
  //   display: inline-block;
  //   width: 100px;
  //   overflow: hidden;
  //   display: flex;
  //   justify-content: space-between;
  // }

  &.value {
    color: #338bea;
  }
}

.record {
  color: #fff;
  min-width: 500px;
  max-width: 80%;
  min-height: 30px;
  border-radius: 4px;
  border: 1px solid #4172a5;
  margin: 0 0 0 30px;
  padding: 10px;

  .sss {
    display: flex;
    justify-content: space-between;

    .state {
      padding: 0 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      background: #1763e8;
      border-radius: 3px;
    }
  }

  &>div {
    margin-bottom: 10px;
  }

  .files {
    color: #1763e8;
    cursor: pointer;
    margin-top: 10px;
  }
}

.imgwrapper {
  display: flex;
  align-items: flex-start;
}

.dateWrqapper {
  min-width: 500px;
  max-width: 80%;
  margin: 0 0 0 30px;
  padding: 10px;
  color: #fff;
  display: flex;
  justify-content: space-between;
}



::v-deep .tsinfoWrapper p {
  margin: 0;
  padding: 0;
  color: #338bea !important;
  padding: 0 !important;
  text-align: left;
  display: flex;
  justify-content: flex-start;
  text-indent: 0 !important;

  font-size: 16px !important;
  line-height: 24px !important;
}

::v-deep .dateWrqapper {
  padding: 0 !important;
  margin-bottom: 5px !important;
}







.textBar {
  display: flex;
  // flex-direction: column;
  margin-bottom: 15px;

  .label {
    display: flex;
    width: 80px;
    justify-content: flex-end;
  }

  .value {
    width: 0;
    flex: 1;
  }
}

::v-deep .el-step__icon{
  width: 17px !important;
  height: 17px !important;
}
::v-deep .el-step__title{
  font-size: 14px;
  line-height: 28px;
}

::v-deep .el-table .el-table__cell{
  padding:3px 0 !important;
}

::v-deep .el-step__icon-inner{
  visibility: hidden !important;
}
</style>
